/**
 * History management for undo/redo functionality
 */
class HtmlHistory {
    constructor() {
        this.stack = [];
        this.currentIndex = -1;
    }

    /**
     * Push a new state to the history stack
     */
    push(state) {
        // Remove any states after the current index
        if (this.currentIndex < this.stack.length - 1) {
            this.stack = this.stack.slice(0, this.currentIndex + 1);
        }

        this.stack.push(state);
        this.currentIndex++;

        // Limit stack size to prevent memory issues
        if (this.stack.length > 50) {
            this.stack.shift();
            this.currentIndex--;
        }
    }

    /**
     * Undo to previous state
     */
    undo() {
        if (this.canUndo()) {
            this.currentIndex--;
            return this.stack[this.currentIndex];
        }
        return null;
    }

    /**
     * Redo to next state
     */
    redo() {
        if (this.canRedo()) {
            this.currentIndex++;
            return this.stack[this.currentIndex];
        }
        return null;
    }

    /**
     * Check if undo is available
     */
    canUndo() {
        return this.currentIndex > 0;
    }

    /**
     * Check if redo is available
     */
    canRedo() {
        return this.currentIndex < this.stack.length - 1;
    }

    /**
     * Get current state
     */
    getCurrentState() {
        return this.stack[this.currentIndex] || null;
    }

    /**
     * Clear all history
     */
    clear() {
        this.stack = [];
        this.currentIndex = -1;
    }
}

export default HtmlHistory;
